module.exports = __webpack_public_path__ + "img/box-light.e4b63bbf.svg";